import axios from 'axios';
import { Message } from 'element-ui';
// import VueCookies from 'vue-cookies';

// 读取环境变量，优先从 .env 文件中配置
const BASE_URL = process.env.NODE_ENV === 'development' ? '/xj' : 'https://www.hnsjb.cn'; //production 线上；development 开发; // 适配 .env 文件配置
const TIMEOUT = 5000; // 增加超时时间，防止请求长时间卡住
// 创建 axios 实例
const service = axios.create({
  baseURL: BASE_URL, // 根据环境自动切换
  timeout: TIMEOUT,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem('token') || '';
    // if (token) {
    //   config.headers['Authorization'] = 'Bearer ' + token;
    // }

    // // **自动处理 GET 和 POST 请求参数**
    // if (config.method.toUpperCase() === 'GET') {
    //   config.params = config.data; // 让 GET 请求支持 data 传参
    // } else if (config.method.toUpperCase() === 'POST') {
    //   config.headers['Content-Type'] = 'application/json'; // 统一使用 JSON
    //   config.data = JSON.stringify(config.data);
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response; // 直接返回数据，简化调用方式
  },
  async (error) => {
    if (!error.response) {
      Message.error('请求失败，请检查网络！');
      return Promise.reject(error);
    }

    // const { status, data } = error.response;

    // switch (status) {
    //   case 401:
    //     Message.error('登录失效，请重新登录');
    //     localStorage.clear();
    //     location.reload();
    //     break;
    //   case 403:
    //     Message.error('没有权限访问');
    //     break;
    //   case 500:
    //     Message.error('服务器错误，请稍后重试');
    //     break;
    //   default:
    //     Message.error(data.message || '请求出错');
    // }

    return Promise.reject(error);
  }
);

// 可选优化（增加请求重试机制）
// service.interceptors.response.use(
//   (response) => response.data,
//   async (error) => {
//     const { config, response } = error;
//     if (!response) {
//       Message.error('请求失败，请检查网络！');
//       return Promise.reject(error);
//     }

//     // **重试机制**
//     if (response.status >= 500 && !config.__retryCount) {
//       config.__retryCount = 1;
//       return service(config);
//     }

//     return Promise.reject(error);
//   }
// );

// **封装 GET & POST 方法，简化调用**
const http = {
  get(url, params = {}, config = {}) {
    return service.get(url, { params, ...config });
  },
  post(url, data = {}, config = {}) {
    return service.post(url, data, { ...config });
  },
};

export default http;
